/**
 * Bezettingsstrook (Epic C-3 — Planbord & indelen, Story C-3.3, UX-C1,
 * FR-15-inline)
 *
 * Toont per dag per dagdeel `ingedeeld N / beschikbaar M` uit de
 * board-payload (AD-16) — telt zelf niets. Story C-4.1 (AC 4) maakt de
 * strook-doorklik naar het bezettingsoverzicht functioneel: de strooktekst
 * blijft hetzelfde, maar de strook is nu zelf een link naar
 * `/planning/bezetting?van=...&tot=...` met dezelfde periode.
 */

import { Link } from 'react-router-dom';
import type { BoardDaySummary } from '@functieloonhuis/shared';
import { formatDateLabel } from '../../werkrooster/utils/dateUtils';

interface OccupancyStripProps {
  days: BoardDaySummary[];
}

export function OccupancyStrip({ days }: OccupancyStripProps) {
  const van = days[0]?.date;
  const tot = days[days.length - 1]?.date;
  const bezettingHref = van && tot ? `/planning/bezetting?van=${van}&tot=${tot}` : '/planning/bezetting';

  return (
    <div
      data-testid="occupancy-strip"
      className="grid gap-1 px-2 py-2 border-t border-[#E2E8F0] bg-gray-50 text-[11px]"
      style={{ gridTemplateColumns: `140px repeat(${days.length}, minmax(90px, 1fr))` }}
    >
      <Link
        to={bezettingHref}
        data-testid="occupancy-strip-link"
        title="Naar het bezettingsoverzicht"
        className="text-gray-500 font-medium hover:text-[#2F5A7A] hover:underline"
      >
        Bezetting →
      </Link>
      {days.map((day) => (
        <div key={day.date} data-testid={`occupancy-${day.date}`} className="text-center text-[#1E293B] whitespace-nowrap">
          <span title={`${formatDateLabel(new Date(`${day.date}T00:00:00`))} — ochtend`}>
            Ocht. {day.morning.assigned} / {day.morning.available}
          </span>
          {' · '}
          <span title={`${formatDateLabel(new Date(`${day.date}T00:00:00`))} — middag`}>
            Mid. {day.afternoon.assigned} / {day.afternoon.available}
          </span>
        </div>
      ))}
    </div>
  );
}
